import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OrgChartBasic from "./OrgChartBasic";

export default function Personel() {
  const { lang = "fa" } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((element) => element.classList.add("visible"));
      return undefined;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("personel.seo.title")}</title>
        <meta name="description" content={t("personel.seo.description")} />
        <link rel="alternate" hrefLang="fa" href={`${window.location.origin}/fa/personel`} />
        <link rel="alternate" hrefLang="en" href={`${window.location.origin}/en/personel`} />
      </Helmet>
      <main className="container personel-page" dir={lang === "en" ? "ltr" : "rtl"}>
        <div className="personel-title fade-in from-right delay-1">
          <span>ARAMIS TEAM</span>
          <h1 className="text-blue1 fs-7">{t("personel.pageTitle")}</h1>
        </div>
        <div className="row text-center personel-board">
          <h2 className="text-blue1 fs-6 mt-5 mb-3 fade-in from-right delay-1">{t("personel.board.title")}</h2>
          <div className="col-md-4" />
          <div className="col-md-4 text-center fade-in from-bottom delay-2">
            <div className="pbox">
              <img src="/assets/horry.jpg" alt={lang === "en" ? "Ali Horry" : "علی حری"} className="img-responsive" />
              <div className="tbox">
                <h3 className="text-blue2 fs-4 mb-3">{lang === "en" ? "Ali Horry" : "علی حری"}</h3>
                <h4 className="text-black-6 fs-2">{t("personel.board.title")}</h4>
                <h5 className="text-black-6 fs-1 mb-2">{lang === "en" ? "M.Sc. in Mechatronics" : "فوق لیسانس مکاترونیک"}</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="row text-center personel-chart-section">
          <h2 className="text-blue1 fs-6 mt-5 mb-3 fade-in from-right delay-1">{t("personel.org.title")}</h2>
          <div className="fade-in from-bottom delay-2"><OrgChartBasic lang={lang} /></div>
        </div>
      </main>
    </>
  );
}
